import { useTranslations } from "use-intl";

import { AccountSection } from "./components/account-section";
import { GeneralSection } from "./components/general-section";

export function SettingsPage() {
	const t = useTranslations("settings");

	return (
		<div className="mx-auto mt-2 w-full max-w-2xl">
			<h1 className="mb-8 text-2xl font-semibold tracking-tight">{t("title")}</h1>

			<div className="flex flex-col gap-14">
				<GeneralSection />
				<AccountSection />
			</div>
		</div>
	);
}
